'use client'

import React, { useState } from 'react';
import { Box, Button, IconButton, InputBase, useMediaQuery, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDeals } from 'app/providers/deals-provider';
import { useAuth } from 'app/providers/auth-provider';

const AsinLookup = () => {
    const { fetchDeals } = useDeals();
    const [showSearch, setShowSearch] = useState(false);
    const [asins, setAsins] = useState('');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { user } = useAuth();

    const handleSearch = (event) => {
        fetchDeals('', [], 1, {}, user, false, asins);
        event.target.blur();
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSearch(event);
        }
    };

    return (
        <Box>
            {!showSearch ? (
                isMobile ? <IconButton
                    onClick={() => setShowSearch(true)}
                    sx={{
                        bgcolor: 'var(--theme-dark, #2B4D59)',
                        color: '#fff',
                        '&:hover': {
                            bgcolor: 'rgba(43, 77, 89, 0.8)',
                        },
                        borderRadius: '8px',
                        p: 1.5
                    }}
                >
                    <SearchIcon />
                </IconButton> : <Button 
                    id="asin-lookup-button-click-tour"
                    variant="contained" 
                    onClick={() => setShowSearch(true)}
                    sx={{
                        bgcolor: 'var(--theme-dark, #2B4D59)',
                        color: '#fff',
                        '&:hover': {
                            bgcolor: 'var(--theme-dark, #2B4D59)',
                            opacity: 0.9,
                        },
                        borderRadius: '8px',
                        px: 2,
                        py: 1,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '14px'
                    }}
                >
                    ASIN Lookup
                </Button>
            ) : (
                <Box
                    sx={{
                        flexGrow: 1,
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        bgcolor: '#fff',
                        border: '1px solid #E0E0E0',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                        overflow: 'hidden',
                        height: '44px'
                    }}
                >
                    <InputBase
                        value={asins}
                        id="asin-lookup-button-input-tour"
                        onChange={e => setAsins(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder="Enter ASIN(s)"
                        inputProps={{
                            'aria-label': 'search',
                            style: {
                                fontSize: '0.85rem',
                            }
                        }}
                        sx={{
                            flex: 1,
                            color: '#1a1a1a',
                            px: 1.5,
                            '& .MuiInputBase-input': {
                                '&::placeholder': {
                                    color: '#666',
                                    opacity: 1,
                                    fontSize: '0.95rem'
                                },
                            }
                        }}
                    />
                    <Box
                        onClick={handleSearch}
                        id="asin-lookup-button-input-search-button-tour"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'var(--theme-dark, #2B4D59)',
                            color: 'white',
                            cursor: 'pointer',
                            borderTopRightRadius: '8px',
                            borderBottomRightRadius: '8px',
                            width: '44px',
                            height: '44px',
                            transition: 'all 0.2s ease',
                            border: 'none',
                            '&:hover': {
                                bgcolor: 'var(--theme-dark, #2B4D59)',
                                opacity: 0.9,
                            },
                        }}
                    >
                        <SearchIcon fontSize="small" />
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default AsinLookup;